<template>
  <div v-if="isLoading" class="loading" :style="{height: `${loadingHeight}px`}" >
    <div class="loader" :style="{paddingTop: `${loadingPadding}px`}">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </div>
    <span>Now Loading</span>
  </div>
</template>
  
<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    loadingHeight: {
      type: String,
      default: '200'
    },
    loadingPadding: {
      type: String,
      default: '50'
    }
  }
}
</script>
  
<style scoped>
.loading {
  text-align: center;
  color: rgb(var(--v-theme-primary));
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
}

.bar {
  display: inline-block;
  width: 3px;
  height: 20px;
  background-color: rgb(var(--v-theme-primary));
  border-radius: 10px;
  animation: scale-up4 1s linear infinite;
}

.bar:nth-child(2) {
  height: 35px;
  margin: 0 5px;
  animation-delay: .25s;
}

.bar:nth-child(3) {
  animation-delay: .5s;
}

@keyframes scale-up4 {
  20% {
    background-color: #ffff;
    transform: scaleY(1.5);
  }

  40% {
    transform: scaleY(1);
  }
}
</style>